<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'changePwd',
})
</script>
<template>
  <div class="dialog-container">
    <ant-Modal v-model:open="state.dialog.isShowDialog" :centered="true" :maskClosable="false" :closable="false"
      :destroyOnClose="true" title="修改密码" :width="517" :keyboard="false">
      <div class="px-[60px] py-[10px]">
        <a-form size="large" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }" ref="formRef" :rules="rules"
          layout="vertical" :model="state.ruleForm">
          <template v-if="state.viewTyle">
            <a-form-item name="password" label-position="right">
              <template #label><span class="form-label">原密码</span></template>
              <a-input-password @input="handlePasswordInput(state.ruleForm.password, 0)" placeholder="请输入原密码"
                v-model:value="state.ruleForm.password" :minlength="8" :maxlength="20" />
            </a-form-item>
          </template>
          <a-form-item name="passwordOne" label-position="right">
            <template #label>
              <div class="form-label">{{ state.viewTyle ? '新密码' :
                '密码需包含大小写字母、数字及特殊符号，长度不少于8个字符！' }}</div>
            </template>
            <div v-if="state.viewTyle" class="text-[12px] my-[8px]">密码需包含大小写字母、数字及特殊符号，长度不少于8 个字符！</div>
            <a-input-password @input="handlePasswordInput(state.ruleForm.passwordOne, 1)" placeholder="请输入密码"
              v-model:value="state.ruleForm.passwordOne" :minlength="8" :maxlength="20" />
          </a-form-item>
          <a-form-item name="passwordTwo" label-position="right">
            <a-input-password @input="handlePasswordInput(state.ruleForm.passwordTwo, 2)" placeholder="再次输入密码"
              v-model:value="state.ruleForm.passwordTwo" :minlength="8" :maxlength="20" />
          </a-form-item>
        </a-form>
      </div>
      <template #footer>
        <div class="dialog-footer-change">
          <ant-button @click="onCancel" v-if="state.viewTyle" class="cancel">取消</ant-button>
          <ant-button class="submit" type="primary" @click="onChangeSurePwd" v-if="state.viewTyle"
            :loading="state.loading.changePwd">确认修改</ant-button>
          <ant-button class="submit" type="primary" @click="onChangeSurePwd" :loading="state.loading.changePwd"
            v-else>确认修改</ant-button>
        </div>
      </template>
    </ant-Modal>
  </div>
</template>

<script setup lang="ts" name="changePwd">
import { reactive, ref } from 'vue'
import { verifyPasswordPowerful, verifyCnAndSpace } from '@/utils/toolsValidate'
import { useLogin } from '@/store/login'
import { useRouter } from 'vue-router'
import { desEncrypt, desChangePwdKey } from '@/utils/des'

import type { Rule } from 'ant-design-vue/es/form'
import { clearUserInfo } from '@/utils/util'
import { message } from 'ant-design-vue'
import { resetBusinessRoutes } from '@/router/businessRoutes'

const loginApi = useLogin()
const router = useRouter()
const formRef = ref()

// 定义子组件向父组件传值/事件
const emit = defineEmits(['refresh', 'create', 'update'])
// 定义变量内容
const state = reactive({
  viewTyle: 0,
  dialog: {
    isShowDialog: false,
    title: '',
    submitTxt: ''
  },
  ruleForm: {
    password: '',
    passwordOne: '',
    passwordTwo: ''
  },
  loading: {
    changePwd: false
  },
  isShowPassword: true,
  isShowPasswordTwo: true
})

const validatePass = (rule: object, value: string, callback: any) => {
  if (value === '') {
    return Promise.reject(new Error('请输入新密码'));
  } else if (!verifyPasswordPowerful(value)) {
    return Promise.reject(new Error('密码需包含大小写字母、数字及特殊符号，长度不少于8 个字符！'));
  } else {
    return Promise.resolve();
  }
}

const validatePass2 = (rule: object, value: string, callback: any) => {
  if (value === '') {
    return Promise.reject(new Error('请再次输入新密码'));
  } else {
    if (value !== state.ruleForm.passwordOne) {
      return Promise.reject(new Error('两次密码输入不一致，请重新输入'));
    } else {
      return Promise.resolve();
    }
  }
}

const rules: Record<string, Rule[]> = {
  password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
  passwordOne: [{ required: true, validator: validatePass, trigger: 'blur' }],
  passwordTwo: [{ required: true, validator: validatePass2, trigger: 'blur' }]
}

// 打开弹窗
const openDialog = async (type: number) => {
  state.viewTyle = type
  state.dialog.isShowDialog = true
  console.log(type, 'type')
}

const onCancel = () => {
  state.dialog.isShowDialog = false
  formRef.value.resetFields()
}

const onChangeSurePwd = () => {
  formRef.value
    .validate()
    .then(async () => {
      let params = state.viewTyle
        ? {
          oldPwd: desEncrypt(state.ruleForm.password, desChangePwdKey),
          pwd: desEncrypt(state.ruleForm.passwordOne, desChangePwdKey)
        }
        : {
          pwd: desEncrypt(state.ruleForm.passwordOne, desChangePwdKey)
        }
      state.viewTyle ? await loginApi.changePwdNeedOldPwd(params) : await loginApi.changePwd(params)
      message.success({
        content: '修改密码成功，请重新登录',
        onClose: () => {
          clearUserInfo()
          resetBusinessRoutes(router)
          loginApi.$reset()
          router.replace({ name: 'login' })
        }
      })
    })
    .catch((error) => {
      console.log('error', error)
    })
}

// 过滤掉中文字符
const handlePasswordInput = (value: string, type: number) => {
  if (type === 0) {
    state.ruleForm.password = verifyCnAndSpace(value)
  } else if (type === 1) {
    state.ruleForm.passwordOne = verifyCnAndSpace(value)
  } else {
    state.ruleForm.passwordTwo = verifyCnAndSpace(value)
  }
}

// 暴露变量
defineExpose({
  openDialog
})
</script>
<style lang="less" scoped>
.changePwd-dialog-title {
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-size: 18px;
  color: #222222;
}

.form-label {
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-size: 14px;
  color: #222222;
}

.dialog-footer-change {
  display: flex;
  align-items: center;
  justify-content: center;

  .cancle-btn,
  .changePwd-btn {
    width: 120px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .changePwd-btn {
    color: #fff;
  }
}
</style>
